import React, { Component } from 'react';

import { MDBRow } from 'mdbreact';
import ImageGallery from 'react-image-gallery';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

class Real13 extends Component {

  render() {
    
    const images = [
      {
        original: require("../../assets/images/gifi/gifi1.jpg"),
        thumbnail: require("../../assets/images/gifi/gifi1.jpg")
      },
      {
        original: require("../../assets/images/gifi/gifi2.jpg"),
        thumbnail: require("../../assets/images/gifi/gifi2.jpg")
      },
      {
        original: require("../../assets/images/gifi/gifi3.jpg"),
        thumbnail: require("../../assets/images/gifi/gifi3.jpg")
      },
      {
        original: require("../../assets/images/gifi/gifi4.jpg"),
        thumbnail: require("../../assets/images/gifi/gifi4.jpg")
      }
    ];

    return (
      <MDBRow className="Real">
        <h1>Réparation du bardage</h1>
        <ImageGallery
          items={images}
          showIndex={true}
          showPlayButton={false}
          showThumbnails={false}
          showFullscreenButton={false}
        />
      </MDBRow>
    )
  }
}

export default Real13;